// extracted by mini-css-extract-plugin
module.exports = {"favoritesWrapper":"_2e3f01f4","folder":"_51998776"};